module.exports = __webpack_public_path__ + "img/img11.0cb1a52e.svg";